export default "__VITE_ASSET__CB5qMGXw__"